// extracted by mini-css-extract-plugin
module.exports = {"container":"cardButton_container__11oYp","placeholder":"cardButton_placeholder__62FKe"};